import { Component, OnInit } from '@angular/core'

import { SESSION_STORAGE_CONSTANTS_CAAS_CONTENT } from '../constants/constant.content'
import {
  ConstantUrls,
  FUND_LITERATURE_ERROR_HOME_URL,
  FUND_LITERATURE_ERROR_SVG_URL,
} from '../constants/constant.urls'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as configURL from '../server/configServer.json'
import { EnvironmentService } from './services/environment/environment.service'
import { Fd3ContentService } from './services/fd3-content/fd3-content.service'
import { ObservableService } from './services/observable-service/observable.service'
import { UserLogonService } from './services/user-logon/user-logon.service'

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  isLoading = true
  isContentAvailable = false
  findLiteratureErrorSvgUrl: string
  findLiteratureErrorHomeUrl: string
  isCoverSpinner = false
  isLoggedOnMonolithURL: string
  isLoggedOnB2BURL: string

  constructor(
    private readonly fd3ContentService: Fd3ContentService,
    private readonly environmentService: EnvironmentService,
    private readonly observerService: ObservableService,
    private readonly userLogonService: UserLogonService,
  ) {}

  ngOnInit(): void {
    this.getEvn()
    this.observerService.coverSpinnerSelected.subscribe((status: boolean) => {
      this.isCoverSpinner = status
    })
  }

  getEvn() {
    this.environmentService.getEnvDetails().subscribe({
      next: (response: any) => {
        this.environmentService.envType = response.envType
        this.findLiteratureErrorSvgUrl =
          configURL[this.environmentService.envType].external.BASE_HOST +
          FUND_LITERATURE_ERROR_SVG_URL
        this.findLiteratureErrorHomeUrl =
          configURL[this.environmentService.envType].external.BASE_HOST +
          FUND_LITERATURE_ERROR_HOME_URL
        this.isLoggedOnMonolithURL =
          configURL[this.environmentService.envType].external.BASE_HOST +
          ConstantUrls.IS_LOGGED_ON
        this.isLoggedOnB2BURL =
          configURL[this.environmentService.envType].B2B_LOGON_SERVICE_URL
        this.getFD3Content()
      },
      error: (error: any) => {
        this.getFD3Content()
        console.error(error)
      },
    })
  }

  public getFD3Content() {
    this.fd3ContentService.getFD3Content().subscribe({
      next: (response) => {
        response.data.fd3popupsList.items[0].strategiespopup['html'] =
          this.parseContent(
            response.data.fd3popupsList.items[0].strategiespopup['html'],
          )
        response.data.fd3tablecontentList.items[0].sechover['html'] =
          this.parseContent(
            response.data.fd3tablecontentList.items[0].sechover['html'],
          )

        sessionStorage.setItem(
          SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
          JSON.stringify(response),
        )
        this.isContentAvailable = true
        this.isLoading = false
        this.userLogonService.isUserLoggedOn(configURL)
      },
      error: () => {
        this.isLoading = false
        this.isContentAvailable = false
      },
    })
  }

  parseContent(data: any) {
    return data
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>')
      .replaceAll('&quot;', '"')
      .replaceAll('&nbsp;', '')
  }
}
